/* eslint-disable indent */
import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
const TimelineDiv = styled.div.withConfig({
  displayName: "TimeLine__TimelineDiv",
  componentId: "ci1bh1-0"
})(["display:flex;justify-content:space-between;width:", "px;"], props => props.width);
export const TimeLine = ({
  dates,
  width
}) => {
  const begDate = dates[0];
  const endDate = dates[1];
  return /*#__PURE__*/React.createElement(TimelineDiv, {
    width: width
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      fontSize: '10px'
    }
  }, begDate), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      fontSize: '10px'
    }
  }, endDate));
};
export default TimeLine;